  <template>

    <div class="prescription-popup">
        <div class="content-custom-fit">
            <div class="popup-header">
             
              <div class="cross" @click="closePopup()"><img src="@/assets/images/arrow.svg" /></div>
            </div>

            <div class="three-content" :class="{'big':!open}">
             <custom-fit-stl-canvas v-if="generatedStlUrl" :stl-url="generatedStlUrl" />
             <div v-else>Model preview will be available after generating a new file</div>
            </div>

            <div class="scan-content" :class="{'open':open}">
              <div class="scan-header" @click="open=!open">
                <div>
                  <div class="initiales">{{ order_item.scan.name[0] }}.</div>
                  <div class="name">{{ order_item.scan.name }}</div>
                </div>
                <img :class="{'open':open}" src="@/assets/images/arrow.svg" />
              </div>
              <div v-if="open" class="scan-content-inner">
                <div class="scan-toggles">
                  <div @click="scanview='3d'" :class="{'active':scanview=='3d'}" class="toggle">
                    <span >3D Scan</span>
                  </div>
                  <div @click="scanview='measurements'" :class="{'active':scanview=='measurements'}" class="toggle">
                    <span>Measurements</span>
                  </div>
                </div>
                <div class="content-inner">
                  <template v-if="scanview=='3d'">
                    <scan-canvas v-if="order_item.scan" :scan="order_item.scan" />
                    <div class="points-count">
                      <div class="legend">Face Datapoints captured:</div>
                      <div class="pt-value">{{pointCloudLineCount}}.</div>
                    </div>
                  </template>
                  <template v-if="scanview=='measurements'">
                    <div class="measures" v-if="measurements">
                      
                      <div class="title">
                        <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                        Morphological Measurements
                      </div>

                      <template>
                        <br />
                        
                        <span class="label">Cantus Distance:</span> <span class="value">{{ measurements.CantusDistance}}mm</span><br />
                      
                        <span class="label">Sphenoidal Width :</span> <span class="value">{{ measurements.SpenoidalWidth}}mm</span><br />
                        <span class="label">Temple Width:</span> <span class="value">{{ measurements.TempleDistance}}mm</span><br />
                        <span class="label">Pantoscopic Angle:</span> <span class="value">{{ measurements.PantoscopicAngle}}°</span><br />
                      


                        <span class="label">Eyebrow Height :</span> <span class="value">{{ measurements.EyeBrowHeight}}mm</span><br />
                        <span class="label">Cheekbone Height :</span> <span class="value">{{ measurements.CheekboneHeight}}mm</span><br />
                      </template>
                      <br />
                      <div class="title">
                        <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                        Optical Measurements
                      </div>
                    
                      <template>
                        <br />
                        <span class="label">Eye to lens distance (Topological):</span> <span class="value">{{ measurements.EyeToLensDistance}}mm</span><br />
                        <span class="label">Final eye to lens distance:</span> <span class="value">{{ goodEyeToLensDistance }}mm</span><br />
                        <span class="label">Close Pupillary Distance:</span> <span class="value">{{ measurements.PupillaryDistance}}mm</span><br />
                        <span class="label">Far Pupillary Distance:</span> <span class="value">{{ measurements.FarPupillaryDistance ? measurements.FarPupillaryDistance : measurements.PupillaryDistance*1+4}}mm</span><br />
                        <span class="label">Pupillary Height:</span> <span class="value">{{ goodPupillaryHeight }}mm</span><br />
            
                      </template>
                      
                      <br />
                      <div class="title">
                        <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                        Nasal Measurements
                      </div>

                      <template>
                        <br />
                      
                        <span class="label">Right Nasal Face Angle :</span> <span class="value">{{ measurements.RightNasalFaceAngle}}°</span>  <br />
                        <span class="label">Left Nasal Face Angle :</span> <span class="value">{{ measurements.LeftNasalFaceAngle}}°</span><br />

                        
                        <span class="label">Right Nasal Caster Angle :</span> <span class="value">{{ measurements.RightNasalCasterAngle}}°</span><br />
                        <span class="label">Left Nasal Caster Angle :</span> <span class="value">{{ measurements.LeftNasalCasterAngle}}°</span><br />
            
                        <span class="label">Nasal Crete Angle :</span> <span class="value">{{ measurements.NoseCreteAngle}}°</span><br />
                
                      </template>
                    
                    </div>
                  </template>
                </div>
              </div>
              
            </div>
           
            <div class="parametric">
              <div class="top-content">
                <div class="parametric-header">
                  <div class="parametric-header-title">Parametric Editor</div>
                </div>
                <div class="parametric-content">
                  <div class="subtitle">Frame Size Parameter</div>
                  <div class="parametric-form">
                    <div class="left-content">
                      <div class="legend">
                        Lens boxing width
                      </div>
                      <input class="range-field" type="range" min="0" :max="caliberMaxIndex" step="1" v-model.number="caliberIndex" />
                    </div>
                    <div class="field" >{{ form.caliber }}</div>
                  </div>
                </div>
                <br />
                <div class="parametric-content">
                  <div class="subtitle">Nose Parameters</div>
                  <div class="parametric-form">
                    <div class="left-content">
                      <div class="legend">
                        Bridge Width
                      </div>
                      <input class="range-field" type="range" min="-2" max="2" step="0.5" v-model="form.bridge_width" />
                    </div>
                    <div class="field" >{{ form.bridge_width*1+bridgeWidthValue*1 }}mm</div>
                  </div>
                  <div class="parametric-form">
                    <div class="left-content">
                      <div class="legend">
                        Nose Face Angle
                      </div>
                      <input class="range-field" type="range" :min="minFaceAngleValue" :max="maxFaceAngleValue" step="0.1" v-model="form.nose_face_angle" />
                    </div>
                    <div class="field" >{{ (form.nose_face_angle*1 + faceAngleValue*1).toFixed(1) }}°</div>
                  </div>
                  <div class="parametric-form">
                    <div class="left-content">
                      <div class="legend">
                        Nose Caster Angle
                      </div>
                      <input class="range-field" type="range" min="-5" max="5" step="0.5" v-model="form.nose_caster_angle" />
                    </div>
                    <div class="field" >{{ (form.nose_caster_angle*1 + casterAngleValue*1).toFixed(1) }}°</div>
                  </div>
                </div>
                <br />
                <div class="parametric-content">
                  <div class="subtitle">Temple Parameters</div>
                  <div class="parametric-form">
                    <div class="left-content">
                      <div class="legend">
                        Temple Length
                      </div>
                      <input class="range-field" type="range" min="-10" max="10" step="0.5" v-model="form.temple_length" />
                    </div>
                    <div class="field" >{{ form.temple_length*1 + templeLengthValue*1 }}mm</div>
                  </div>
                  <div class="parametric-form">
                    <div class="left-content">
                      <div class="legend">
                        Temple Opening Angle
                      </div>
                      <input class="range-field" type="range" :min="minTempleOpeningAngleValue" :max="maxTempleOpeningAngleValue" step="0.1" v-model="form.temple_opening_angle" />
                    </div>
                    <div class="field" >{{ (form.temple_opening_angle*1+templeOpeningValue*1).toFixed(1) }}°</div>
                  </div>
                  
                </div>
                <br />
                
                <div class="legend-bottom">
                  Note: The Bridge Width and Lens boxing width parameters influence the Frame Width. Actual Frame Width is {{ calculateFrameWidth }}mm
                </div>
              </div>

           
              <b-button variant="secondary" :disabled="generating" @click="generateFiles()">
                {{ generating ? 'Generating...' : 'Generate Files' }}
              </b-button>
             

            </div>
        </div>
        <div v-if="generating" class="generate-progress">
          <div class="content-progress">
            <div class="generate-progress-header">
            
              <span>{{ requestProgress }}%</span>
              <div class="loading-icon"><img src="@/assets/images/loading.svg" /></div>
            </div>
            <div class="generate-progress-track">
              <span class="generate-progress-text">Generating files...</span>
              <div class="generate-progress-fill" :style="{ width: `${requestProgress}%` }"></div>
            </div>
          </div>
        </div>
        <download-files-popup @closeDownloadFilesPopupEv="displayDlFilesPopup=false" :svg-url="generatedSvgUrl" :stl-url="generatedStlUrl" :stl-front-url="generatedStlFrontUrl" :stl-temple-l-url="generatedStlTempleLUrl" :subd-url="generatedSubDUrl" :stl-temple-r-url="generatedStlTempleRUrl" :fitting-result="fittingResult" v-if="displayDlFilesPopup" />
    </div>
  </template>
  
  
  <script>

  import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
  import {APIRequest, Auth} from '@simb2s/senseye-sdk'
  import { VueGoodTable } from 'vue-good-table'
  import ScanPopup from '../../components/ScanPopup.vue'
  import AdjustmentReport from '../order-review/AdjustmentReport.vue'

  import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import emitter from 'tiny-emitter/instance'
  import ScanCanvas from './ScanCanvas.vue'
  import DownloadFilesPopup from './DownloadFilesPopup.vue'
  import CustomFitStlCanvas from './CustomFitStlCanvas.vue'

   

  export default {
    components: {
      BCard,
      BCardText,
      VueGoodTable,
            BAvatar,
            ScanCanvas,
            CustomFitStlCanvas,
            DownloadFilesPopup,
      BOverlay,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      BModal,
      BButton,
      BRow,
      ScanPopup,
      PrescriptionPopup,
      AdjustmentReport

    },
    props:['order_item','fittingResult'],
    data() {
      const CALIBER_VALUES = (this.order_item.glass.id==74 || this.order_item.glass.id==79) ? [48, 49, 50, 51, 52] : this.order_item.glass.id==95 ? [54.8, 55.8, 56.8, 57.8, 58.8]  : this.order_item.glass.id==72 ? [48.5, 49.4, 50.2, 51.3, 52.4] : this.order_item.glass.id==71 ? [40.9, 41.9, 42.9, 43.9, 44.9] :  this.order_item.glass.id==92 ? [42,42.5, 43, 43.5, 44, 44.5, 45,45.5,46] : [43.9, 44.9, 45.9, 46.9, 47.9]
      return {
        CALIBER_VALUES,
        pointCloudLineCount:null,
        prescription:null,
        open:true,
        scanview:'3d',
        measurements:null,
        generating:false,
        displayDlFilesPopup:false,
        requestProgress:0,
        requestProgressInterval:null,
        generatedStlPath:null,
        generatedStlUrl:null,
        generatedSvgPath:null,
        generatedSvgUrl:null,
        generatedSubDUrl:null,
        generatedStlFrontUrl:null,
        generatedStlTempleLUrl:null,
        generatedStlTempleRUrl:null,
        form:{
          caliber: this.order_item.glass.id==92 ? CALIBER_VALUES[4]  : CALIBER_VALUES[2],
          enable_engraving:true,
          save_subd:true,
          enable_decorations:true,
          bridge_width:0,
          nose_face_angle:0,
          nose_caster_angle:0,
          temple_length:0,
          temple_opening_angle:this.order_item.glass.id==74 ? -0.1 : this.order_item.glass.id==79 ? -2.9 : this.order_item.glass.id==71 ? -2.5 : this.order_item.glass.id==80 ? -2.4 : this.order_item.glass.id==80 ? -3 : 0
        }
      }
    },
    computed: {
      bridgeWidthValue() {

        if(this.order_item.glass.id==74)
        {
        return 21.5
        }
        else if(this.order_item.glass.id==79)
        {
          return 24.5
        }
        else if(this.order_item.glass.id==72)
        {
          return 20
        }
        else if(this.order_item.glass.id==71)
        {
          return 26
        }
        else if(this.order_item.glass.id==80)
        {
          return 26.2
        }
        else if(this.order_item.glass.id==92)
        {
          return 27.2
        }
        else if(this.order_item.glass.id==96)
        {
          return 27.2
        }
        else if(this.order_item.glass.id==95)
        {
          return 18.5
        }
        return 21.5
      },
      minFaceAngleValue() {
        if(this.order_item.glass.id==74)
        {
          return -0.5

        }
        else if(this.order_item.glass.id==79)
        {
          return -3.4

        }
        else if(this.order_item.glass.id==72)
        {
          return -3.8
        }
        else if(this.order_item.glass.id==71)
        {
          return -4.7
        }
        else if(this.order_item.glass.id==80)
        {
          return -0.2
        }
        else if(this.order_item.glass.id==92)
        {
          return -2.3
        }
        else if(this.order_item.glass.id==96)
        {
          return -5.1
        }
        else if(this.order_item.glass.id==95)
        {
          return 0
        }
        return -0.5
      },
      maxFaceAngleValue() {
        if(this.order_item.glass.id==74)
        {
          return 1.5

        }
        else if(this.order_item.glass.id==79)
        {
          return 1.7

        }
        else if(this.order_item.glass.id==72)
        {
          return 1.1
        }
        else if(this.order_item.glass.id==71)
        {
          return 2.3
        }
        else if(this.order_item.glass.id==80)
        {
          return 0.2
        }
        else if(this.order_item.glass.id==92)
        {
          return 1.4
        }
        else if(this.order_item.glass.id==96)
        {
          return 3.1
        }
        else if(this.order_item.glass.id==95)
        {
          return 0
        }
        return 1.5
      },
      faceAngleValue() {

        if(this.order_item.glass.id==74)
        {
        return 21.2

        }
        else if(this.order_item.glass.id==79)
        {
          return 24.1

        }
        else if(this.order_item.glass.id==72)
        {
          return 21.8
        }
        else if(this.order_item.glass.id==71)
        {
          return 15.9
        }
        else if(this.order_item.glass.id==80)
        {
          return 21.8

        }
        else if(this.order_item.glass.id==92)
        {
          return 20.6

        }
        else if(this.order_item.glass.id==96)
        {
          return 14.2
        }
        else if(this.order_item.glass.id==95)
        {
          return 22.9
        }
        return 21.2
      },
      minTempleOpeningAngleValue() {
        if(this.order_item.glass.id==74)
        {
          return -2

        }
        else if(this.order_item.glass.id==79)
        {
          return -4.3

        }
        else if(this.order_item.glass.id==72)
        {
          return -3.4
        }
        else if(this.order_item.glass.id==71)
        {
          return -6
        }
        else if(this.order_item.glass.id==80)
        {
          return -3.2
        }
        else if(this.order_item.glass.id==92)
        {
          return -3
        }
        else if(this.order_item.glass.id==96)
        {
          return -3.2
        }
        else if(this.order_item.glass.id==95)
        {
          return -4.9
        }
        return -2
      },
      maxTempleOpeningAngleValue() {
        if(this.order_item.glass.id==74)
        {
          return 2

        }
        else if(this.order_item.glass.id==79)
        {
          return 5

        }
        else if(this.order_item.glass.id==72)
        {
          return 5
        }
        else if(this.order_item.glass.id==71)
        {
          return 5
        }
        else if(this.order_item.glass.id==80)
        {
          return 5
        }
        else if(this.order_item.glass.id==92)
        {
          return 5
        }
        else if(this.order_item.glass.id==96)
        {
          return 5
        }
        else if(this.order_item.glass.id==95)
        {
          return 9.9
        }
        return 2
      },
      casterAngleValue() {

        if(this.order_item.glass.id==74)
        {
          return 11.1


        }
        else if(this.order_item.glass.id==79)
        {
          return 2.1

        }
        else if(this.order_item.glass.id==72)
        {
          return 15
        }
        else if(this.order_item.glass.id==71)
        {
          return 14.4
        }
        else if(this.order_item.glass.id==80)
        {
          return 15
        }
        else if(this.order_item.glass.id==92)
        {
          return 27.9
        }
        else if(this.order_item.glass.id==96)
        {
          return 10.8
        }
        else if(this.order_item.glass.id==95)
        {
          return 18.9
        }
        return 11.1
      },
      templeLengthValue() {

        if(this.order_item.glass.id==74)
        {
          return 0

        }
        else if(this.order_item.glass.id==79)
        {
          return 147

        }
        else if(this.order_item.glass.id==72)
        {
          return 144
        }
        else if(this.order_item.glass.id==71)
        {
          return 141
        }
        else if(this.order_item.glass.id==80)
        {
          return 142
        }
        else if(this.order_item.glass.id==92)
        {
          return 147
        }
        else if(this.order_item.glass.id==96)
        {
          return 143.7
        }
        else if(this.order_item.glass.id==95)
        {
          return 146.5
        }
        return 0
      },
      templeOpeningValue() {

        if(this.order_item.glass.id==74)
        {
          return 2.2

        }
        else if(this.order_item.glass.id==79)
        {
          return 4.5

        }
        else if(this.order_item.glass.id==72)
        {
          return 3.4
        }
        else if(this.order_item.glass.id==71)
        {
          return 6
        }
        else if(this.order_item.glass.id==80)
        {
          return 3.4
        }
        else if(this.order_item.glass.id==92)
        {
          return 3
        }
        else if(this.order_item.glass.id==96)
        {
          return 3.4
        }
        else if(this.order_item.glass.id==95)
        {
          return 4.9
        }
        return 2.2
      },
      calculateFrameWidth() {
       
        let baseWidth
        if(this.form.caliber==this.CALIBER_VALUES[0])
        {
          baseWidth=139.6
          if(this.order_item.glass.id==74)
          {
            baseWidth=139.6
          }
          else if(this.order_item.glass.id==79)
          {
            baseWidth=140

          }
          else if(this.order_item.glass.id==72)
          {
            baseWidth=140

          }
          else if(this.order_item.glass.id==71)
          {
            baseWidth=130.8
          }
          else if(this.order_item.glass.id==80)
          {
            baseWidth=141
          }
          else if(this.order_item.glass.id==92)
          {
            baseWidth=136
          }
          else if(this.order_item.glass.id==96)
          {
            baseWidth=137.6
          }
          else if(this.order_item.glass.id==95)
          {
            baseWidth=143
          }
         
        }
        else if(this.form.caliber==this.CALIBER_VALUES[1])
        {
          baseWidth=141.6
          if(this.order_item.glass.id==74)
          {
            baseWidth=141.6
          }
          else if(this.order_item.glass.id==79)
          {
            baseWidth=142
          }
          else if(this.order_item.glass.id==72)
          {
            baseWidth=142
          }
          else if(this.order_item.glass.id==71)
          {
            baseWidth=132.8
          }
          else if(this.order_item.glass.id==80)
          {
            baseWidth=143
          }
          else if(this.order_item.glass.id==92)
          {
            baseWidth=137
          }
          else if(this.order_item.glass.id==96)
          {
            baseWidth=139.6
          }
          else if(this.order_item.glass.id==95)
          {
            baseWidth=145
          }
        }
        else if(this.form.caliber==this.CALIBER_VALUES[2])
        {
          baseWidth=143.7
          if(this.order_item.glass.id==74)
          {
            baseWidth=143.7
          }
          else if(this.order_item.glass.id==79)
          {
            baseWidth=144
          }
          else if(this.order_item.glass.id==72)
          {
            baseWidth=144
          }
          else if(this.order_item.glass.id==71)
          {
            baseWidth=134.8
          }
          else if(this.order_item.glass.id==80)
          {
            baseWidth=145
          }
          else if(this.order_item.glass.id==92)
          {
            baseWidth=138
          }
          else if(this.order_item.glass.id==96)
          {
            baseWidth=141.6
          }
          else if(this.order_item.glass.id==95)
          {
            baseWidth=147
          }
        }
        else if(this.form.caliber==this.CALIBER_VALUES[3])
        {
          baseWidth=145.7
          if(this.order_item.glass.id==74)
          {
            baseWidth=145.7
          }
          else if(this.order_item.glass.id==79)
          {
            baseWidth=146
          }
          else if(this.order_item.glass.id==72)
          {
            baseWidth=146
          }
          else if(this.order_item.glass.id==71)
          {
            baseWidth=136.8
          }
          else if(this.order_item.glass.id==80)
          {
            baseWidth=147
          }
          else if(this.order_item.glass.id==92)
          {
            baseWidth=139
          }
          else if(this.order_item.glass.id==96)
          {
            baseWidth=143.6
          }
          else if(this.order_item.glass.id==95)
          {
            baseWidth=149
          }
        }
        else if(this.form.caliber==this.CALIBER_VALUES[4])
        {
          baseWidth=147.7
          if(this.order_item.glass.id==74)
          {
            baseWidth=147.7
          }
          else if(this.order_item.glass.id==79)
          {
            baseWidth=148
          }
          else if(this.order_item.glass.id==72)
          {
            baseWidth=148
          }
          else if(this.order_item.glass.id==71)
          {
            baseWidth=138.8
          }
          else if(this.order_item.glass.id==80)
          {
            baseWidth=149
          }
          else if(this.order_item.glass.id==92)
          {
            baseWidth=140
          }
          else if(this.order_item.glass.id==96)
          {
            baseWidth=145.6
          }
          else if(this.order_item.glass.id==95)
          {
            baseWidth=151
          }
        }
        else if(this.form.caliber==this.CALIBER_VALUES[5])
        {
          baseWidth=149.7
         
          if(this.order_item.glass.id==92)
          {
            baseWidth=141
          }
          
        }
        else if(this.form.caliber==this.CALIBER_VALUES[6])
        {
          baseWidth=149.7
         
          if(this.order_item.glass.id==92)
          {
            baseWidth=142
          }
          
        }
        else if(this.form.caliber==this.CALIBER_VALUES[7])
        {
          baseWidth=149.7
         
          if(this.order_item.glass.id==92)
          {
            baseWidth=143
          }
          
        }
        else if(this.form.caliber==this.CALIBER_VALUES[8])
        {
          baseWidth=149.7
         
          if(this.order_item.glass.id==92)
          {
            baseWidth=144
          }
          
        }
        return baseWidth+this.form.bridge_width*1
      },
      caliberMaxIndex() {
        return this.CALIBER_VALUES.length - 1
      },
      caliberIndex: {
        get() {
          const idx = this.CALIBER_VALUES.indexOf(this.form.caliber)
          return idx >= 0 ? idx : 2
        },
        set(index) {
          const i = Number(index)
          this.form.caliber = this.CALIBER_VALUES[i] ?? this.CALIBER_VALUES[0]
        },
      },
    },
    methods:{
        closePopup() {
            this.$emit('closeCustomFitPopupEv')
        },
        rangeToNormalizedFactor(value, min, max) {
          if (max === min) return 0
          const v = Math.min(max, Math.max(min, Number(value)))
          return (2 * (v - min)) / (max - min) - 1
        },
        rangeToNormalizedFactorAtZero(value, min, max, zero = 0) {
          if (max === min) return 0
          const v = Math.min(max, Math.max(min, Number(value)))
          if (v <= zero) {
            if (zero === min) return -1
            return (v - zero) / (zero - min)
          }
          if (max === zero) return 1
          return (v - zero) / (max - zero)
        },
        isEmptyGeneratePayload(payload) {
          if (payload == null || payload === '') return true
          if (typeof payload === 'object' && !Array.isArray(payload) && Object.keys(payload).length === 0) {
            return true
          }
          return false
        },
        async applyGeneratePayload(payload,inputs) {
         
          const stlPath = payload.STL_Filepath_full
          const stlFrontPath = payload.STL_Filepath_front
          const stlTempleLPath = payload.STL_Filepath_templeL
          const stlTempleRPath = payload.STL_Filepath_templeR
          const subDPath = payload.SubD_Filepath
          const svgPath = payload.exportDrawingSVG_filepath
          if (!stlPath) {
            throw new Error('STL Mesh Filepath not found in response')
          }

          console.log('stlPath',stlPath)

          this.generatedSvgPath = svgPath
          this.generatedStlPath = stlPath
          this.generatedStlUrl = this.mapServerPathToPublicUrl(stlPath)
          this.generatedSvgUrl = this.mapServerPathToPublicUrl(svgPath)
          this.generatedStlFrontUrl = this.mapServerPathToPublicUrl(stlFrontPath)
          this.generatedStlTempleLUrl = this.mapServerPathToPublicUrl(stlTempleLPath)
          this.generatedStlTempleRUrl = this.mapServerPathToPublicUrl(stlTempleRPath)
          this.generatedSubDUrl = subDPath ? this.mapServerPathToPublicUrl(subDPath) : null
          let datas={
            order_item:{id:this.order_item.id},
            stl_url:this.generatedStlUrl,
            stl_frame_url:this.generatedStlFrontUrl,
            stl_temple_left_url:this.generatedStlTempleLUrl,
            stl_temple_right_url:this.generatedStlTempleRUrl,
            subd_url:this.generatedSubDUrl ? this.generatedSubDUrl : null,
            svg_url:this.generatedSvgUrl,
            inputs:JSON.stringify(inputs)
          }

          let adjustmentResult=await APIRequest.create('adjustment-results', datas)

         

          this.$emit('applyAdjustmentResultEv',adjustmentResult)
          if (!this.generatedStlUrl) {
            throw new Error('Unable to map STL server path to public URL')
          }
        },
        async generateFiles() {
          if (this.generating) return
          this.generatedStlUrl=null
          this.generating = true
          this.startRequestProgress()
   
          console.log('model_id',this.order_item.glass.id)



          let file_name = 'custom-frame-v99z8-JMM-Dealan-v0.27.gh';
          if (this.order_item.glass.id == 74) {
              file_name = 'custom-frame-v99z8-JMM-Dealan-v0.27.gh';
          }  else if (this.order_item.glass.id == 79) {
              file_name = 'custom-frame-v100z-JMM-Enzo-v0.5.gh';
          } else if (this.order_item.glass.id == 72) {
              file_name = 'custom-frame-v100z-JMM-Molino-v0.7.gh';
          } else if (this.order_item.glass.id == 71) {
              file_name = 'custom-frame-v100x-JMM-Zephirin-44-v0.7.gh';
          } else if (this.order_item.glass.id == 80) {
              file_name = 'custom-frame-v100z-JMM-Julien-v0.3.gh';
          }
          else if (this.order_item.glass.id == 96) {
              file_name = 'custom-frame-v100y-JMM-Zephirin-47-v0.2.gh';
          }
          else if (this.order_item.glass.id == 92) {
              file_name = 'custom-frame-v100z-JMM-Leclair-v0.6.gh';
          }
          else if (this.order_item.glass.id == 95) {
            file_name = 'custom-frame-v101b-JMM-Yves-v0.1.gh';
          }

          let face_angle_steps
          let temple_opening_steps

          if (this.order_item.glass.id == 74) {
              face_angle_steps = 21
              temple_opening_steps = 41
          }  else if (this.order_item.glass.id == 79) {
            face_angle_steps = 52
            temple_opening_steps = 94
          } else if (this.order_item.glass.id == 72) {
            face_angle_steps = 50
            temple_opening_steps = 85
          } else if (this.order_item.glass.id == 71) {
            face_angle_steps = 71
            temple_opening_steps = 111
          } else if (this.order_item.glass.id == 80) {
            face_angle_steps = 5
            temple_opening_steps = 83
          }
          else if (this.order_item.glass.id == 92) {
            face_angle_steps = 38
            temple_opening_steps = 81
          }
          else if (this.order_item.glass.id == 96) {
            face_angle_steps = 83
            temple_opening_steps = 83
          }
          else if (this.order_item.glass.id == 95) {
            face_angle_steps = 0
            temple_opening_steps = 100
          }

          const inputs = {
            filename:file_name,
            pupillary_distance:this.measurements.FarPupillaryDistance ? this.measurements.FarPupillaryDistance : this.measurements.PupillaryDistance*1+4,
            model_id:this.order_item.glass.id,
            caliberIndex: this.caliberIndex,
            enable_engraving: true,
            enable_decorations: true,
            save_subd: this.form.save_subd,
            face_angle_steps:face_angle_steps,
            temple_opening_steps:temple_opening_steps,
            bridge_width: this.rangeToNormalizedFactor(this.form.bridge_width, -2, 2).toFixed(1),
            nose_face_angle: this.rangeToNormalizedFactorAtZero(this.form.nose_face_angle, this.minFaceAngleValue, this.maxFaceAngleValue, 0).toFixed(1),
            nose_caster_angle: this.rangeToNormalizedFactor(this.form.nose_caster_angle, -5, 5).toFixed(1),
            temple_length: this.rangeToNormalizedFactor(this.form.temple_length, -10, 10).toFixed(1),
            temple_opening_angle: this.rangeToNormalizedFactorAtZero(this.form.temple_opening_angle, this.minTempleOpeningAngleValue, this.maxTempleOpeningAngleValue, 0).toFixed(1),
          }

          const maxAttempts = 2
          let lastError = null

          try {
            for (let attempt = 1; attempt <= maxAttempts; attempt++) {
              try {
                const response = await APIRequest.post_request('api/generate-files-new', inputs)
                const payload = response.data

                console.log('payload',payload)

                let json_url=payload.url 

                let json_response=await fetch(json_url)
                let json_data=await json_response.json()

                console.log('json_data',json_data)

                

                if (this.isEmptyGeneratePayload(payload)) {
                  throw new Error('Empty payload received')
                }

                await this.applyGeneratePayload(json_data,inputs)
                
                this.open = false
                this.displayDlFilesPopup = true

                
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Success',
                    text: 'STL generated and loaded.',
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                return
              } catch (e) {
                lastError = e
                console.error(`Generate files attempt ${attempt}/${maxAttempts} failed`, e)
                if (attempt < maxAttempts) continue
              }
            }

            throw lastError || new Error('Failed to generate files after 3 attempts')
          } catch (e) {
            console.error('Error generating files', e)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                text: 'Failed to generate files.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.completeRequestProgress()
            this.generating = false
          }
        },
        startRequestProgress() {
          this.clearRequestProgressInterval()
          this.requestProgress = 5
          this.requestProgressInterval = setInterval(() => {
            // Keep headroom for completion on real response.
            if (this.requestProgress < 90) {
              this.requestProgress += Math.max(1, Math.round((90 - this.requestProgress) / 12))
            }
          }, 1500)
        },
        completeRequestProgress() {
          this.clearRequestProgressInterval()
          this.requestProgress = 100
          setTimeout(() => {
            this.requestProgress = 0
          }, 300)
        },
        clearRequestProgressInterval() {
          if (this.requestProgressInterval) {
            clearInterval(this.requestProgressInterval)
            this.requestProgressInterval = null
          }
        },
        extractStlFrontFilepath(payload) {
          if (!payload || !Array.isArray(payload.values)) return null
          const stlValue = payload.values.find(value => value.ParamName === 'STL Export Data')
          if (!stlValue || !stlValue.InnerTree) return null
          const firstBranch = Object.values(stlValue.InnerTree)[0]
          if (!Array.isArray(firstBranch) || firstBranch.length === 0) return null
          const rawPath = firstBranch[0]?.data
          if (typeof rawPath !== 'string') return null
          const dataPath = JSON.parse(JSON.parse(rawPath))
          
          return dataPath.STL_Filepath_front.replace(/^"+|"+$/g, '').trim()
        },
        extractStlTempleLFilepath(payload) {
          if (!payload || !Array.isArray(payload.values)) return null
          const stlValue = payload.values.find(value => value.ParamName === 'STL Export Data')
          if (!stlValue || !stlValue.InnerTree) return null
          const firstBranch = Object.values(stlValue.InnerTree)[0]
          if (!Array.isArray(firstBranch) || firstBranch.length === 0) return null
          const rawPath = firstBranch[0]?.data
          if (typeof rawPath !== 'string') return null
          const dataPath = JSON.parse(JSON.parse(rawPath))
          
          return dataPath.STL_Filepath_templeL.replace(/^"+|"+$/g, '').trim()
        },
        extractSubDFilepath(payload) {
          if (!payload || !Array.isArray(payload.values)) return null
          const stlValue = payload.values.find(value => value.ParamName === 'STL Export Data')
          if (!stlValue || !stlValue.InnerTree) return null
          const firstBranch = Object.values(stlValue.InnerTree)[0]
          if (!Array.isArray(firstBranch) || firstBranch.length === 0) return null
          const rawPath = firstBranch[0]?.data
          if (typeof rawPath !== 'string') return null
          const dataPath = JSON.parse(JSON.parse(rawPath))

          
         if(dataPath.exportSubD==true)
         {
          return dataPath.SubD_Filepath.replace(/^"+|"+$/g, '').trim()
         }
         else
         {
          return null
         }
          
          
        },
        extractStlTempleRFilepath(payload) {
          if (!payload || !Array.isArray(payload.values)) return null
          const stlValue = payload.values.find(value => value.ParamName === 'STL Export Data')
          if (!stlValue || !stlValue.InnerTree) return null
          const firstBranch = Object.values(stlValue.InnerTree)[0]
          if (!Array.isArray(firstBranch) || firstBranch.length === 0) return null
          const rawPath = firstBranch[0]?.data
          if (typeof rawPath !== 'string') return null
          const dataPath = JSON.parse(JSON.parse(rawPath))
          
          return dataPath.STL_Filepath_templeR.replace(/^"+|"+$/g, '').trim()
        },
        extractStlMeshFilepath(payload) {
          if (!payload || !Array.isArray(payload.values)) return null
          const stlValue = payload.values.find(value => value.ParamName === 'STL Mesh Filepath')
          if (!stlValue || !stlValue.InnerTree) return null
          const firstBranch = Object.values(stlValue.InnerTree)[0]
          if (!Array.isArray(firstBranch) || firstBranch.length === 0) return null
          const rawPath = firstBranch[0]?.data
          if (typeof rawPath !== 'string') return null
          return rawPath.replace(/^"+|"+$/g, '').trim()
        },
        extractSvgMeshFilepath(payload) {
          if (!payload || !Array.isArray(payload.values)) return null
          const svgValue = payload.values.find(value => value.ParamName === 'exportDrawingSVG_filepath')
          if (!svgValue || !svgValue.InnerTree) return null
          const firstBranch = Object.values(svgValue.InnerTree)[0]
          if (!Array.isArray(firstBranch) || firstBranch.length === 0) return null
          const rawPath = firstBranch[0]?.data
          if (typeof rawPath !== 'string') return null
          return rawPath.replace(/^"+|"+$/g, '').trim()
        },
        
        mapServerPathToPublicUrl(filePath) {
          if (!filePath || typeof filePath !== 'string') return null
          if (/^https?:\/\//i.test(filePath)) return filePath

          const normalizedPath = filePath.replace(/\\/g, '/').trim()
          const dataSegment = '/data/'
          const dataIndex = normalizedPath.toLowerCase().indexOf(dataSegment)
          if (dataIndex === -1) return null

          const relativePath = normalizedPath.slice(dataIndex).replace('/data','')
          return `https://rhino.visages.com${relativePath}`
        },
    },
    async mounted() {

      if(this.order_item.size)
      {
        if(this.order_item.size=="xs")
        {
          this.form.caliber=this.CALIBER_VALUES[0]
        }
        else if(this.order_item.size=="s")
        {
          this.form.caliber=this.CALIBER_VALUES[1]
        }
        else if(this.order_item.size=="m")
        {
          this.form.caliber=this.CALIBER_VALUES[2]
        }
        else if(this.order_item.size=="l")
        {
          this.form.caliber=this.CALIBER_VALUES[3]
        }
        else if(this.order_item.size=="xl")
        {
          this.form.caliber=this.CALIBER_VALUES[4]
        }

      }

      if(this.fittingResult)
      {
    
        let inputs=JSON.parse(this.fittingResult.inputs)
        this.form.bridge_width=inputs.bridge_width
        this.form.nose_face_angle=inputs.nose_face_angle
        this.form.nose_caster_angle=inputs.nose_caster_angle
        this.form.temple_length=inputs.temple_length
        this.form.temple_opening_angle=inputs.temple_opening_angle
        this.open = false
        this.displayDlFilesPopup = true

        this.generatedSvgPath = this.fittingResult.svg_url
        this.generatedStlPath = this.fittingResult.stl_url
        this.generatedStlUrl = this.fittingResult.stl_url
        this.generatedSvgUrl = this.fittingResult.svg_url
        this.generatedStlFrontUrl = this.fittingResult.stl_frame_url
        this.generatedStlTempleLUrl = this.fittingResult.stl_temple_left_url
        this.generatedStlTempleRUrl = this.fittingResult.stl_temple_right_url
      }

      let pointCloud=await APIRequest.get_request('api/scans/point-cloud/'+this.order_item.scan.id)
 
 if (pointCloud.data.pointCloud) {
   try {
     const text = pointCloud.data.pointCloud
          // filter(Boolean) removes empty last line if file ends with \n
          this.pointCloudLineCount = text.split('\n').filter(Boolean).length
          
        } catch (e) {
          console.error('Error fetching point cloud file', e)
        }
      }
      if(this.order_item.scan.measurements)
      {
        let measurements=this.order_item.scan.measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        
    
        this.measurements=JSON.parse(measurements)

      }
    },
    beforeUnmount() {
      this.clearRequestProgressInterval()
    },
  
  }
  
  
    </script>
  
    <style scoped lang="scss" >
  @import '@core/scss/vue/libs/vue-good-table.scss';
  
  .generate-progress
  {
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background: rgba(0, 0, 0, 0.1);
    z-index: 9999999;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    .content-progress
    {
      position:absolute;
      top:50%;
      width:450px;
      left:50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 5px;
      padding: 20px;
    }
  }
  .three-content.big 
  {
    width:calc(70% - 40px);
  }
  .three-content
  {
    width:calc(40% - 40px);
    height:100%;
    color:#999;
    text-align: center;
    padding: 20px;
    position: absolute;
    top:0;
    left:0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .scan-content.open
  {
    height:calc(100% - 40px);
  }
  .scan-content
  {
    display: flex;
    z-index: 4;
    flex-direction: column;
    justify-content: space-between;
    width:30%;
    gap: 10px;
    height:fit-content;
  
    top:20px;
    right:calc(30% + 40px);
    
    position: absolute;
    .scan-header
    {
      cursor: pointer;
      border-radius: 5px;
      background: #fff;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img
      {
        transform: rotate(90deg);
      }
      img.open
      {
        transform: rotate(270deg);
      }
      >div
      {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .initiales
      {
        width:32px;
        height:32px;
        display:flex;
        align-items: center;
        justify-content: center;
        background: #f1f1f1;
        border-radius: 5px;
       
        color: #999;
      }
      .name
      {
       
        color: #000;
      }
    }
    .scan-content-inner
    {
      border-radius: 5px;
      background: #fff;
      flex:1;
      padding: 20px;
    }
  }
  .generate-progress
  {
    margin-top: 12px;
  }
 
  .generate-progress-track
  {
    margin-top:50px;
    width:100%;
    position:relative;
    height:40px;
    background:#f1f1f1;
    border-radius:5px;
    overflow:hidden;
  }
  .generate-progress-text
  {
    color:#fff;
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    left:20px;
  }
  .generate-progress-header
  {
    font-size:50px;
    display:flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .generate-progress-fill
  {
    height:100%;
    background:#000;
    transition: width 0.2s ease;
  }
  .parametric
  {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width:30%;
    height:calc(100% - 40px);
    top:20px;
    right:20px;
    position: absolute;
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    .parametric-header
    {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      border-bottom: 1px solid #f1f1f1;
      padding-bottom: 10px;
      .parametric-header-title
      {
        padding:5px 10px;
        background: #f1f1f1;
        border-radius: 5px;
      }
    }
    .parametric-content
    {
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: space-between;
    }
    .subtitle
    {
      font-size:15px;
      font-weight:400;
    }
    .parametric-form
    {
      display: flex;
      justify-content: space-between;
      gap:10px;
      align-items: flex-end;
      .left-content
      {
        flex:1;
      }
      >div
      {
       
        .range-field
        {
          -webkit-appearance: none;     /*nécessaire pour Chrome */
          appearance: none;
          color: #C5C5C5;                  /* sert pour couleur de référence, via currentColor, pour le curseur */
          height: 3px;
          border-radius: 5px;
          background: #C5C5C5;  
          width:100%;
          &::-webkit-slider-thumb
          {
            -webkit-appearance: none;
            appearance: none;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #C5C5C5;
          }
        }
      }
      .field
      {
        font-size:13px;
        line-height:13px;
        border:1px solid #999;
        border-radius: 5px;
        padding: 5px;
        width:66px;
      }
      .legend
      {
        display:flex;
        align-items: center;
        gap: 5px;
        font-size:12px;
        font-weight:400;
        color: #999;
      }
    }
  }
  .points-count .legend
  {
    color:#999;
  }
  .scan-toggles
  {
    padding:5px;
    background: #f1f1f1;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    .toggle
    {
      cursor: pointer;
      padding: 5px 10px;
      border-radius: 5px;
      flex:1;
      color: #000;
      text-align: center;
    }
    .toggle.active
    {
      background: #fff;
    }
  }
  .points-count
  {
    text-align: right;
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 5;
  }
  .prescription-info
  {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #f1f1f1;
    padding:5px 10px 5px 5px;
    border-radius: 5px;
    .prescription-info-left
    {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .icon
    {
        width:32px;
        height:32px;
        display:flex;
        background: #fff;
        border-radius: 5px;
        padding: 5px;
        align-items: center;
        justify-content: center;
    }
    .name
    {
        
    }
    .date
    {
        font-size:14px;
        color: #999;
    }
  }
 .cross
 {
    cursor: pointer;
    width:32px;
   
    height:32px;
    display:flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #fff;
    img
    {
      transform: rotate(180deg);
        width:10px;
    }
 }
  .popup-header
  {
    display: flex;
    position:relative;
    z-index: 3;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
   
    padding-bottom: 20px;
    .popup-header-title
    {
        font-size:22px;
        font-weight:600;
    }
  }
  .title-icon
  {
    width:32px;
    height:32px;
    display:flex;
    background: #f1f1f1;
    border-radius: 5px;
  
    align-items: center;
    justify-content: center;
  }
  .prescription-popup
  {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    z-index: 9999999;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    .content-custom-fit
    {
      
       position: relative;
        width:calc(100% - 40px) ;
        height:calc(100% - 40px);
   
        background: #f1f1f1;
        border-radius: 5px;
        padding: 20px;
    }
  }
  .measures .title 
{
  margin-bottom:0px;
  font-size:14px;
  display:flex;
  color:#000;

  align-items: center;
  justify-content: flex-start;
  gap:10px;
}
.label
{
  color:#999;
  font-size:12px;
}
.value
{
  float:right;
  color:#000;
  font-size:12px;
}
.measures
{
 margin-top:20px;
 
}
.loading-icon
{
  width:40px;
  height:40px;
  display:flex;
  align-items: center;
  justify-content: center;
  background: #f1f1f1;
  border-radius: 5px;
  padding: 5px;
  img
  {
    width:20px;
    height:20px;
  }
}
.legend-bottom
{
  color:#999;
  font-size:11px;
  line-height:1;
  margin-top:20px;
  background:#f1f1f1;
  padding:10px;
  border-radius: 5px;
}
.top-content
{
  max-height:calc(100vh - 170px);
  overflow-y: auto;
} 

</style>